<script setup lang="ts">
  import { useRouter } from 'vue-router';

  interface Props {
    title: string;
    description: string;
    linkDescription: string;
    cancelText: string;
    confirmText: string;
  }

  const props = defineProps<Props>();

  const emit = defineEmits<{
    (e: 'close', value: boolean): void;
  }>();

  const router = useRouter();

  const model = defineModel({ default: true });

  function closeModal(): void {
    model.value = false;
    emit('close', false);
  }

  function handleRedirect(): void {
    router.push({
      name: 's-channels',
    });

    closeModal();
  }
</script>

<template>
  <bv-modal
    :cancel-text="props.cancelText"
    :confirm-text="props.confirmText"
    :model-value="model"
    :title="props.title"
    @cancel="closeModal"
    @confirm="handleRedirect"
  >
    <div class="flex flex-col gap-3 text-sm font-normal">
      <p>
        {{ props.description }}
      </p>

      <p>
        {{ props.linkDescription }}
      </p>
    </div>
  </bv-modal>
</template>
